// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { ArquivosCotaUsuario } from "../interfaces/ArquivosCotaUsuario";

export const atualizarArquivoService = async (
  arquivoCotaUsuarioId: number,
  data: Partial<ArquivosCotaUsuario>
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/arquivo-cota-usuario/${arquivoCotaUsuarioId}`;
    try {
      const response = await axios.put(URL, data, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
